<template>
  <div class="red-box">
    <div class="box-title-view">{{title}}</div>
    <div class="red-box-content">
      <slot></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: "tableRedBox",
  props:{
    title:''
  }
}
</script>

<style lang="scss" scoped>
.red-box{
  width: calc(100% - 2px);
  height: auto;
  min-height: 60px;
  border: #e8556f 1px solid;
  margin-top: 30px;
  border-radius: 5px;
  overflow: hidden;

}
.red-box-content{
  width: calc(100% - 20px);
  margin: 10px;
}
.box-title-view{
  width:fit-content;
  width:-webkit-fit-content;
  width:-moz-fit-content;
  padding: 5px 10px 5px 7px;
  background-color: #e8556f;
  color: #ffffff;
  font-size: 12px;
  border-radius: 0px 0 5px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/business/tableRedBox.vue